import "../styles/main.scss";

import "./use-cases/onLoad";

import createModals from "./modules/modals";
import createAccordions from "./modules/accordions";
import createTabs from "./modules/tabs";

import createSwipers from "./modules/swipers";

import createRentCalcs from "./modules/rentCalcs";

import createAPISearch from "./modules/apiSearch";

window.addEventListener('DOMContentLoaded', () => {
  createModals();
  createAccordions();
  createTabs();

  createSwipers();

  createRentCalcs();

  createAPISearch();
});
